export default "__VITE_ASSET__C6_9t0QQ__"